import { useState } from 'react'

import { ExpiresDate } from '~/components/ExpiresDate'
import { SwitchNetworkButton } from '~/components/SwitchNetworkButton'
import Tile from '~/components/Tile'
import { CONFIG } from '~/lib/config'

import { AboutLockInfoWithChange } from '../AboutLockInfoWithChange'
import type { Locked } from '../useLockChangeDetails'

import { useVESISParams } from '~/hooks/useVESISParams'
import { useIncreaseUnlockTime } from './useIncreaseUnlockTime'
import { useNewUnlockChanges } from './useNewUnlockChanges'

import styles from './IncreaseUnlockTime.pcss'

interface Props {
	locked?: Locked
}

export function IncreaseUnlockTime({ locked }: Props) {
	const { config } = useVESISParams()

	const [weeks, setWeeks] = useState(0)

	const { mutate, isLoading } = useIncreaseUnlockTime(locked, weeks)

	const { stats, change } = useNewUnlockChanges(locked, weeks)

	let buttonText
	if (isLoading) {
		buttonText = 'Saving changes....'
	} else if (weeks) {
		buttonText = 'Change Lock'
	} else {
		buttonText = 'Enter Weeks Prolongation'
	}

	return (
		<>
			<div className={styles.container}>
				<ExpiresDate
					className={styles.date}
					disabled={!locked}
					min={locked?.end.toNumber()}
					value={weeks}
					onChange={setWeeks}
				/>
				<div className={styles.content}>
					<div className={styles.title}>LOCK CHANGES</div>
					<div className={styles.changes}>
						<AboutLockInfoWithChange
							change={
								change && !change.totalRewards.isZero()
									? change.totalRewards
									: undefined
							}
							label={`${
								weeks > 0 ? 'New' : ''
							} Est. Total Rewards:`}
							postfix="SIS"
							value={stats?.totalRewards}
							invertPlaceholder
						/>
					</div>
				</div>
			</div>
			<Tile.Footer>
				<SwitchNetworkButton
					block
					color="black"
					disabled={isLoading || !locked || !weeks}
					onClick={() => {
						mutate(undefined, {
							onSuccess() {
								setWeeks(0)
							},
						})
					}}
					requiredChainId={config.chain.id}
				>
					{buttonText}
				</SwitchNetworkButton>
			</Tile.Footer>
		</>
	)
}
